import React, { Component } from 'react'
import withSpinning from '../../HOC/withSpinning'
import CustomSelect from '../CustomSelect'
import { compose } from 'recompose'
import withUrlFetch from '../withUrlFetch'

class ClientsSelect extends Component {
  render() {
    const { keyAtr = '_id' } = this.props
    return <CustomSelect {...this.props} placeholder={'Select a Client'} keyAtr={keyAtr} valueAtr={'member.fn'} />
  }
}

ClientsSelect.propTypes = {}
ClientsSelect.defaultProps = {}

export default compose(
  withUrlFetch({
    name: 'clients',
    url: `clients?status=Active`,
    cache: true,
    forceFetch: false,
  }),
  withSpinning
)(ClientsSelect)
